import { getNullableIntegerSchema } from 'src/compass/shared/schemas';
import * as Yup from 'yup';

export const PropertySchema = Yup.object().shape({
  claimsDashboardDaysLeft: getNullableIntegerSchema('Claims Dashboard Days Left')
    .required('Claims Dashboard Days Left is required.')
    .moreThan(0, 'Claims Dashboard Days Left must be greater than 0'),
  fwdContractInitialDays: getNullableIntegerSchema('Fwd Contract Initial Days')
    .required('Fwd Contract Initial Days is required.')
    .moreThan(0, 'Fwd Contract Initial Days must be greater than 0'),
  dueRemindersLastSent: Yup.date().nullable(),
  dueWarningDaysLeft: Yup.string()
    .nullable()
    .max(255, 'Due Warning Days Left must be at most 255 characters')
    .matches(/^\s*\d+(\s*,\s*\d+)*\s*$/, {
      message: 'Due Warning Days Left must be a comma separated list of numbers',
      excludeEmptyString: true,
    }),
  dueSubject: Yup.string()
    .nullable()
    .max(255, 'Due Warning Email Subject must be at most 255 characters'),
  dueBody: Yup.string().nullable(),
});
